import CryptoJS from 'crypto-js';
import { ENCRYPTION_KEY } from './Constant';

export const encrypt = (data) => {
  if (!data) return null;
  return CryptoJS.AES.encrypt(JSON.stringify(data), ENCRYPTION_KEY).toString();
};


export const decrypt = (data) => {
  try {
    if (!data) return null;
    const bytes = CryptoJS.AES.decrypt(data, ENCRYPTION_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted ? JSON.parse(decrypted) : null;
  } catch (error) {
    console.error('Decryption failed:', error.message);
    return null;
  }
};

